<script>
  import { onMount, onDestroy } from "svelte";
  import { l } from "$lib/Utils/l10n.svelte";
  import Toast from "$lib/UI/Toast.svelte";
  import Action from "$lib/UI/Action/Action.svelte";
  import { goto } from "$app/navigation";
  import FramePopup from "$lib/App/FramePopup.svelte";
  import ActionBar from "$lib/UI/Action/ActionBar.svelte";
  import { action, selectedAction, actions } from "$lib/App/actions-store";
  import title from "$lib/App/title-store";
  import infoContext from "$lib/App/info-context-store";
  import { call } from "$lib/Api/Api.svelte";
  import user from "$lib/App/user-store";
  import { userMenuItems } from "$lib/Utils/Constants.svelte";
  import zorgverlenerTypes from "$lib/Config/zorgverlener-type-store";
  import zorgAanbiederTypes from "$lib/Config/zorgaanbieder-type-store";
  import addressTypes from "$lib/Config/address-types-store";
  import sources from "$lib/Config/source-store";
  import gegevensDiensten from "$lib/Config/gegevensdiensten-store";
  import interactions from "$lib/Config/interactions-store";
  import nameTypes from "$lib/Config/name-types-store";
  import types from "$lib/Config/types-store";
  import classes from "$lib/Config/classes-store";
  import reason from "$lib/App/reason-store";
  import Block from "$lib/UI/Dialog/Block.svelte";
  import searchResults from "$lib/App/search-results-store";
  import { updated } from "$app/stores";
  import Confirmation from "$lib/UI/Dialog/Confirmation.svelte";
  import MessageStrip from "$lib/UI/MessageStrip.svelte";

  let version = {
    main: l("onbekend"),
  };

  let announcement = {
    title: l("Aankondiging"),
    link: null,
  };

  let infoItems = userMenuItems;
  let progressMessage = undefined;
  let updateSwitch = false;

  const noInfo = {
    title: l("geen informatie beschikbaar"),
    link: "about:blank",
  };
  let info = noInfo;
  let mode = null;
  let idleTimer = undefined;

  function baseTarget() {
    document.body.addEventListener(
      "click",
      function (e) {
        // e.target was the clicked element
        if (e.target && e.target.nodeName == "A") {
          e.target.target = "_blank";
        }
      },
      true,
    );
  }

  function authenticate() {
    call("sessions", "state")
      .then((state) => {
        if (!!state && state.active) {
          call("sessions", "authenticated")
            .then((claims) => {
              user.set({
                ...$user,
                ...claims,
                mandate: null,
                authenticated: true,
              });
            })
            .catch(() => {
              user.clear();
              goto("/signin");
            });
        } else {
          if (!!state) {
            zorgIDState.set(state);
          }
          user.clear();
          goto("/offline");
        }
      })
      .catch(() => {
        user.clear();
        goto("/offline");
      });
  }

  onMount(() => {
    authenticate();
    baseTarget();
    resetTimer();
    document.addEventListener("keydown", resetTimer);
    document.addEventListener("click", resetTimer);
    document.addEventListener("submit", resetTimer);
    document.addEventListener("DOMMouseScroll", resetTimer);
    document.addEventListener("mousewheel", resetTimer);
    call("version", "get").then((data) => {
      version = data;
      infoItems[6].description = version.main;
    });

    zorgverlenerTypes.load();
    zorgAanbiederTypes.load();
    addressTypes.load();
    //authorIcons.load();
    sources.load();
    interactions.load();
    gegevensDiensten.load();
    nameTypes.load();
    types.load();
    classes.load();
  });

  function clearTimer() {
    if (idleTimer != undefined) {
      clearTimeout(idleTimer);
    }
  }

  function resetTimer() {
    clearTimer();
    idleTimer = setTimeout(doTimeout, 1000 * 60 * 15);
  }

  function doTimeout() {
    searchResults.clear();
    progressMessage = l("Door inactiviteit wordt u automatisch afgemeld");
    call("sessions", "close")
      .then(() => {
        user.clear();
        progressMessage = undefined;
        reason.set(
          l("U bent automatisch afgemeld na 15 minuten zonder activiteit."),
        );
        goto("/signedout");
      })
      .catch(() => {
        user.clear();
        progressMessage = undefined;
        reason.set(
          l("U bent automatisch afgemeld na 15 minuten zonder activiteit."),
        );
        goto("/signedout");
      });
  }

  function doHome() {
    searchResults.clear();
    action.set({
      id: "home",
      action: "home",
    });
  }

  function doLogout() {
    progressMessage = l("U wordt afgemeld");
    searchResults.clear();
    call("sessions", "close")
      .then(() => {
        user.clear();
        progressMessage = undefined;
        reason.set(l("U hebt u zelf afgemeld."));
        goto("/signedout");
      })
      .catch(() => {
        user.clear();
        progressMessage = undefined;
        goto("/signedout");
      });
  }

  function doClose() {
    mode = null;
  }

  const infoUnsubscribe = infoContext.subscribe((context) => {
    updateInfo(context);
  });

  const updatedUnsubscribe = updated.subscribe((u) => {
    if (u && !updateSwitch) {
      updateSwitch = true;
    }
  });

  const userUnsubscribe = user.subscribe((u) => {
    if (!!u) {
      if (u.authenticated) {
        infoItems[0].title = !!u.commonName ? u.commonName : "";
        infoItems[0].description = !!u.organizationName
          ? u.organizationName + " (" + u.uziRegisterSubscriberNumber + ")"
          : !!u.uziRegisterSubscriberNumber
            ? "URA : " + u.uziRegisterSubscriberNumber
            : "URA onbekend";
        infoItems[2].title = "Afmelden";
        infoItems[2].description = "Afmelden";
      } else {
        infoItems[0].title = "";
        infoItems[0].description = "Niet aangemeld";
        infoItems[2].title = "Aanmelden";
        infoItems[2].description = "Aanmelden";
      }
    }
  });

  onDestroy(() => {
    if (!!infoUnsubscribe) {
      infoUnsubscribe();
    }
    if (!!userUnsubscribe) {
      userUnsubscribe();
    }
    if (updatedUnsubscribe) {
      updatedUnsubscribe();
    }
    clearTimer();
  });

  function updateInfo(c) {
    let inf = {
      title: c,
      link: "/zorgabdoc",
    };

    inf.link += "/#" + c;

    if (!!!inf.link) {
      inf.link = noInfo.link;
    } else {
      if (!!!inf.title) {
        inf.title = inf.link;
      }
    }
    if (!!!inf.title) {
      inf.title = noInfo.title;
    }
    info = inf;
  }

  function doShowInfo() {
    if (!!info.mode && info.mode === "link") {
      window.open(info.link);
    } else {
      mode = "show-info";
    }
  }

  function doInfoContext(event) {
    const context = $infoContext;
    if (!!context) {
      updateInfo(context);
      doShowInfo();
    }
  }

  function doUserAction(event) {
    if (event.detail.action === "show-info") {
      updateInfo(!!event.detail.id ? event.detail.id : "default");
      doShowInfo();
    } else if (event.detail.action === "show-user") {
    } else if (event.detail.action === "logout") {
      if ($user.authenticated) {
        doLogout();
      } else {
        goto("/signedout");
      }
    } else if (event.detail.action === "refresh") {
      window.location.href = "/";
    }
  }

  function doSelectAction(event) {
    action.set(event.detail);
  }

  function doAccept() {
    call("auth", "reference")
      .then(() => {
        document.location.reload();
      })
      .catch(() => {
        document.location.reload();
      });
  }

  function doReload() {
    updateSwitch = false;
    window.location.reload(true);
  }

  function doUpdateSwitch() {
    updateSwitch = false;
  }
</script>

<svelte:head>
  <title>{l("ZORG-AB") + " : " + $title}</title>
</svelte:head>
<div class="app">
  {#if !!progressMessage}
    <Block message={progressMessage} />
  {/if}
  <div class="branding-header">
    <header class="branding-toolbar">
      <Action
        id="home"
        icon="home"
        size="small"
        on:select={doHome}
        styleClass="action-highlight"
      />

      <span class="theme">{$title}</span>

      <div class="buttons">
        <Action
          id="info"
          icon="question"
          size="small"
          styleClass="action-light"
          on:select={doInfoContext}
        />

        <Action
          id="user"
          icon="user"
          size="small"
          menuPop="left"
          items={infoItems}
          styleClass="action-highlight"
          on:select={doUserAction}
        />
      </div>
    </header>
  </div>
  <div class="app-actionbar">
    <ActionBar>
      <div class="orientation">
        <span />
        {#each $actions as action (action.id)}
          {#if !!!action.position || action.position === "top"}
            <Action
              id={action.id}
              icon={action.icon}
              title={action.title}
              items={action.items}
              menuPop={action.menuPop}
              menuVisible={action.menuVisible}
              disabled={action.disabled}
              selected={$selectedAction.id === action.id}
              styleClass={!!action.styleClass
                ? action.styleClass
                : "action-default"}
              action={action.action}
              on:select={doSelectAction}
            />
          {/if}
        {/each}
      </div>
      <div class="orientation" slot="bottom">
        <span />
        {#each $actions as action (action.id)}
          {#if !!action.position && action.position === "bottom"}
            <Action
              id={action.id}
              icon={action.icon}
              title={action.title}
              items={action.items}
              tooltip={action.tooltip}
              menuPop={action.menuPop}
              selected={$selectedAction.id === action.id}
              menuVisible={action.menuVisible}
              styleClass={!!action.styleClass
                ? action.styleClass
                : "action-default"}
              action={action.action}
              on:select={doSelectAction}
            />
          {/if}
        {/each}
      </div>
    </ActionBar>
  </div>
  <div class="app-container">
    {#if $user && $user.mandateId}
      <MessageStrip type="info">
        {l(
          "Let op! U treedt op dit moment als gemandateerde voor " +
            $user.mandate.mandator +
            ".",
        )}
      </MessageStrip>
    {/if}
    <slot />
  </div>
  <footer>
    <span class="footer-text">
      Heeft u vragen, opmerkingen of wilt u dat wij contact met u opnemen, mail
      dan naar: <a href="mailto:ZORG-AB@vzvz.nl">ZORG-AB@vzvz.nl</a>
    </span>
    <span class="footer-link">
      <a href="/zorgabdoc/#privacyverklaring">Privacyverklaring</a>
    </span>
  </footer>
  <Toast />
</div>
{#if updateSwitch}
  <Confirmation
    offsetTopLeft={200}
    id="update"
    title={l("Applicatie update")}
    message={l(
      "Er is een nieuwe versie van ZORG-AB Webportaal beschikbaar. Opnieuw laden?<br/>Let op! Het kan zijn dat een aparte ververs actie nodig is in uw browser.<br/><br/>De specifieke toetsencombinaties voor een harde 'refresh' variëren per browser en besturingssysteem, maar over het algemeen houdt u de Ctrl- (of Cmd-)toets ingedrukt en dan F5 of Shift + R.",
    )}
    okButtonText={l("Ok")}
    cancelButtonText={l("Annuleren")}
    on:cancel={doUpdateSwitch}
    on:continue={doReload}
  />
{/if}
{#if mode === "show-info"}
  <FramePopup link={info.link} title={info.title} on:close={doClose} />
{:else if mode === "announcement"}
  <FramePopup
    title={announcement.title}
    link={announcement.link}
    on:close={doAccept}
  />
{/if}

<style>
  .app {
    background-color: var(--app-background);
    min-height: 100vh;
  }

  .footer-text {
    width: 100%;
    text-align: center;
  }

  footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 2rem;
    background-color: var(--background-active);
    color: var(--theme-color);
    text-align: center;
    padding: 0.5rem;
    font-size: smaller;
    display: flex;
    justify-content: space-between;
  }

  header {
    width: 100%;
    top: 0;
    left: 0;
    height: 3rem;
    background-color: var(--background-active);
    display: flex;
    justify-content: space-between;

    align-items: center;

    background-image: var(--image-header);
    background-repeat: no-repeat;
    background-size: 150px;
    background-position: 1% 50%;
  }

  .theme {
    margin-left: 1rem;
    color: var(--theme-color);
  }
  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .branding-toolbar {
    background: transparent;
    padding-left: 15px;
  }
  .branding-header {
    width: 100%;
    height: var(--branding-height);
    background-image: var(--branding-image);
    background-repeat: no-repeat;
    background-size: var(--branding-image-width);
    background-position: var(--branding-image-position);
    background-color: var(--background-header);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .app-actionbar {
    background: var(--background-action);
    height: calc(100vh - (var(--branding-height) + 20px));
    width: 70px;
    position: absolute;
    left: 0;
  }

  .orientation {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .app-container {
    margin-left: 70px;
    padding: 1.5rem;
    height: calc(100vh - var(--branding-height));
    overflow-y: auto;
  }

  @media screen and (max-width: 700px) {
    .orientation {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      overflow-y: auto;
    }

    .app-container {
      margin-left: initial;
      padding: 1.5rem;
      height: calc(100vh - var(--branding-height));
    }

    .app-actionbar {
      background: var(--background-action);
      height: 90px;
      width: 100%;
      position: initial;
      left: 0;
    }
  }
</style>
